import { ReactNode, useEffect, useRef } from "react";
import {
  FallbackProps,
  ErrorBoundary as ReactErrorBoundary,
} from "react-error-boundary";
import Page from "../../../components/src/Page";
import { Alert } from "react-bootstrap";
import { usePathname } from "next/navigation";

const ErrorView = ({ resetErrorBoundary }: FallbackProps) => {
  const pathname = usePathname();
  const errorPathname = useRef<string | null>(null);

  useEffect(() => {
    if (errorPathname.current === null) {
      errorPathname.current = pathname;
    }

    if (errorPathname.current !== pathname) {
      resetErrorBoundary();
    }
  }, [pathname]);

  // TODO: Log the received error via Sentry

  return (
    <Page.Body>
      <Alert>Something went wrong. Please try refreshing the page.</Alert>
    </Page.Body>
  );
};

const ErrorBoundary = ({ children }: { children: ReactNode }) => {
  return (
    <ReactErrorBoundary FallbackComponent={ErrorView}>
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
